import A11yDialog from 'a11y-dialog';
import { disableScroll, enableScroll } from './scroll';

let dialogs = {};

export function initDialog(elementOrSelector) {
  const element =
    typeof elementOrSelector === 'string'
      ? document.getElementById(elementOrSelector)
      : elementOrSelector;

  if (!elementOrSelector) {
    console.warn('dialog element not found');
    return null;
  }

  if (dialogs[element.id]) {
    return dialogs[element.id];
  }

  const dialog = new A11yDialog(element);
  dialogs[element.id] = dialog;

  dialog.on('show', (event) => {
    disableScroll();
  });
  dialog.on('hide', (event) => {
    enableScroll();
  });

  return dialog;
}
